export const ACTION_CODE = "GET_ALL_CONTRACTORS"
